import { useState, useCallback } from "react";

/* Persists sidebar open/closed state in localStorage */
export function useSidebarState(sectionKey: string) {
  const storageKey = `soc:sidebar:${sectionKey}`;

  const [open, setOpenRaw] = useState<boolean>(() => {
    try {
      return localStorage.getItem(storageKey) === "1";
    } catch {
      return false;
    }
  });

  const setOpen = useCallback(
    (value: boolean | ((prev: boolean) => boolean)) => {
      setOpenRaw((prev) => {
        const next = typeof value === "function" ? value(prev) : value;
        try {
          if (next) localStorage.setItem(storageKey, "1");
          else localStorage.removeItem(storageKey);
        } catch {}
        return next;
      });
    },
    [storageKey],
  );

  const close = useCallback(() => setOpen(false), [setOpen]);

  return [open, setOpen, close] as const;
}
